<template>
  <div>
    <Input
      v-model="nameHand"
      placeholder="请输入"
      :clearable="clearable"
      :readonly="!isHand"
      @on-clear="clear"
    >
      <Button slot="append" icon="md-car" @click="openGroup = true"> </Button>
    </Input>

    <Drawer
      :placement="placement"
      :closable="false"
      v-model="openGroup"
      width="450"
      draggable
      class="my-drawer"
    >
      <car-tool
        @car="reCar"
        :filter="filter"
        :filterGroup="filterGroup"
      ></car-tool>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["name", "placement", "filter", "filterGroup", "isHand", "clearable"],
  data() {
    return {
      openGroup: false,
      nameHand: "",
    };
  },
  methods: {
    reCar(v) {
      this.openGroup = false;
      this.$emit("update:id", v.id);
      this.$emit("update:name", v.carNo);
      this.$emit("update:deviceNo", v.deviceNo);
      this.$emit("car", v);
    },
    clear() {
      this.$emit("update:id", "");
      this.$emit("update:name", "");
      this.$emit("update:deviceNo", "");
    },
  },
  watch: {
    name(v) {
      this.nameHand = v;
    },
    nameHand(v) {
      this.$emit("update:name", v);
    },
  },
  mounted() {
    this.nameHand = this.name;
    
    console.log(this.clearable);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/selectCar.vue